import React, { Fragment, useState, useEffect } from "react";
import Autocomplete from "react-google-autocomplete";
import FirstSlider from "./firstSlider/FirstSlider";
import SecondSlider from "./secondSlider/SecondSlider";
import ThirdSlider from "./thirdSlider/ThirdSlider";
import FourthSlider from "./fourthSlider/FourthSlider";
import FifthSlider from "./fifthSlider/FifthSlider";
import { apiData } from "../../../actions";
import DataLoader from "../../../Utils/DataLoader";
import { UsePlaceAuth } from "../../../AppContext/AppContext";
import { useNavigate } from "react-router-dom/dist";
import { Audio_Tour, setPlace } from "../../../Redux/Action/Action";
import { useDispatch, useSelector } from "react-redux";
import SpcificPageModal from "../../Modals/SpcificPageModal";

function AudioTour() {
  const dispatch = useDispatch();
  const place = useSelector(state => state.place)
  const [tourData, setTourData] = useState("");
  const [inclusiveScript, setInclusiveScript] = useState("");
  const [loader, setLoader] = useState(false);
  const [searchTriggered, setSearchTriggered] = useState(false);
  let navigate = useNavigate()

  const GetTour = async () => {
    setLoader(true);
    let payload = { city: place };
    if (place) {
      let apiRes = await apiData.audioTour(payload);
      if (apiRes?.status >= 200 && apiRes?.status <= 399) {
        setTourData(apiRes?.data?.data);
      }
    }
    setLoader(false);
    setSearchTriggered(false); // hide loader in slider-main
  }
  const GetWigoTourScript = async () => {
    let payload = { city: place };
    setLoader(true);
    let apiRes = await apiData.getWigoTour(payload);
    if (apiRes?.status >= 200 && apiRes?.status <= 399) {
      setInclusiveScript(apiRes?.data?.data[0]?.content?.split('"')[1]);
    }
    setLoader(false);
    setSearchTriggered(false); // hide loader in slider-main
  };

  const handleSearch = (e) => {
    if (e.key.toLowerCase() === "enter") {
      e.preventDefault();
      setSearchTriggered(true);
      setLoader(true); // Show loader immediately
      const cityName = e.target.value.toLowerCase();
      setPlace(cityName); // Assuming this updates global state
      navigate(`/audio-tour/${cityName}`);
    }
  };
  useEffect(() => {
    document.getElementById("InclusiveScript").innerHTML = ""
    let script = document.createElement('script');
    setLoader(true)
    script.src = inclusiveScript
    // .replace(/(?<=items=)\d+/,"20")
    document.getElementById("InclusiveScript").appendChild(script);
    setLoader(false)
    GetWigoTourScript();
    GetTour();
    dispatch(Audio_Tour())
  }, [place]);

  const [specificModal, setSpecificModal] = useState(false);
  useEffect(() => {
    const hasSeenPopup = localStorage.getItem("hasSeenSpecficPopup"); // Check if the modal has already been shown

    if (!hasSeenPopup) {
      // If the modal hasn't been shown before
      setSpecificModal(true); // Show the modal
      localStorage.setItem("hasSeenSpecficPopup", "true"); // Mark as shown
    }

    if (place && !hasSeenPopup) {
      setSpecificModal(true); // Show modal for place-specific logic if not shown yet
    }

    // Save a timestamp when the user navigates away
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        localStorage.setItem("lastSeen", Date.now());
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [place]); // Depend on `place` to re-check modal logic if it changes
  const localSelectedCity = localStorage.getItem('selectedCity');
  return (
    <Fragment>
      <div className="banner-section rest-sec audio">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="hotel-tab-pane" role="tabpanel" aria-labelledby="hotel-tab" tabIndex="0">
                  <div className="select-form restaurent-sec">
                    <form>
                      <div className="choose-sec">
                        <Autocomplete
                          className="form-control"
                          apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                          placeholder={
                            localSelectedCity && localSelectedCity !== "undefined" && place
                              ? place.replace(/\b\w/g, (x) => x.toUpperCase())
                              : "Search for a city or place"
                          }
                          onPlaceSelected={async (city) => {
                            if (city && city.formatted_address) {
                              setLoader(true);
                              const cityName = city.formatted_address.split(',')[0].toLowerCase();
                              await dispatch(setPlace(cityName));
                              localStorage.setItem('selectedCity', city.formatted_address.split(',')[0]);
                              navigate(`/audio-tour/${cityName}`);
                            }
                          }}
                          onKeyPress={handleSearch}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flight-sec exitment-sec tour-slider">
        <div data-aos="zoom-in-right" className="slider-main">
          <div id="InclusiveScript">
            {searchTriggered && <DataLoader />} {/* Show loader here */}
          </div>
        </div>
        <div className="container">
          <div className="row">
            {!loader ? (
              <section className="client-sec comedy">
                <FirstSlider tourData={tourData[0]} />
                <SecondSlider tourData={tourData[1]} />
                <ThirdSlider tourData={tourData[2]} />
                <FourthSlider tourData={tourData[3]} />
                <FifthSlider tourData={tourData[4]} />
              </section>
            ) : (
              <DataLoader />
            )}
          </div>
        </div>
      </div>
      <>
        {specificModal && (
          <SpcificPageModal
            specificModal={specificModal}
            setSpecificModal={setSpecificModal}
          />
        )}
      </>

    </Fragment>
  );
}
export default AudioTour;
